<template>
  <div
    class="grid-item"
    :class="name"
    :style="`--item-color:${color}; grid-area: ${name};`"
  >
    <h3 class="result-wrapper">
      <span class="result-value"><slot name="value"></slot></span>
      <span class="result-label"><slot name="label"></slot></span>
    </h3>
    <p class="description"><slot name="description"></slot></p>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      required: true,
      type: String
    },
    color: {
      required: true,
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-item {
  border-top: 1px solid var(--clr-light);
  padding: var(--spacing-sm) 0;
  display: block;
  padding-right: var(--horizontal-overflow);
  padding-left: var(--horizontal-overflow);
}

.grid-item:nth-of-type(odd) {
  padding-right: calc(var(--spacing-lg) / 2);
}

.grid-item:nth-of-type(even) {
  padding-left: calc(var(--spacing-lg) / 2);
}

.result-wrapper,
.result-value,
.result-label {
  display: block;
}

.result-wrapper {
  color: var(--item-color);
}

.result-value {
  font-weight: var(--fw-bold);
  font-size: var(--fs-22);
  line-height: 1;
}

.result-label {
  font-weight: var(--fw-light);
  font-size: var(--fs-18);
}

.description {
  font-style: italic;
  font-size: var(--fs-14);
  color: var(--clr-dark);
}

@media screen and (min-width: 766px) {
  .grid-item:nth-of-type(odd) {
    padding-left: var(--spacing-md);
    border-left: 1px solid var(--clr-light);
  }

  .grid-item:nth-of-type(even) {
    padding-right: var(--spacing-md);
    border-right: 1px solid var(--clr-light);
  }
}

@media screen and (min-width: 989px) {
  .grid-item {
    padding: var(--spacing-md);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .result-value,
  .result-label {
    display: inline;
    line-height: 1;
  }

  .result-value {
    font-size: var(--fs-32);
  }

  .result-label {
    font-size: var(--fs-22);
  }
}
</style>